// @flow
import React from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import locale from '../../assets/locale';
import Card from '../../components/Card';
import { H2 } from '../../components/Typography';
import Input from '../../components/Input';
import Button from '../../components/Button';
import styles from './styles.module.scss';
import P from '../../components/Typography/P';
import actionTypes from '../../store/auth/actionTypes';

// type Props = {
// };

const ResetPassword = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.api.RESET_PASSWORD.loading);
  const initialFormState = {
    email: '',
  };

  const formik = useFormik({
    initialValues: initialFormState,

    validateOnBlur: false,
    validateOnChange: false,

    onSubmit: (e) => {
      dispatch({ type: actionTypes.RESET_PASSWORD, payload: e });
    },

    validate: (values) => {
      const errors = {};

      if (!values.email) {
        errors.email = locale.errors.account.email;
      }

      return errors;
    },
  });

  const { values, errors, dirty } = formik;

  const isButtonDisabled = !dirty;
  return (
    <form onSubmit={formik.handleSubmit}>
      <Card
        use="light"
        className={styles.containerForm}
        title={<H2 color="dark" className={styles.title}>Reset password</H2>}
      >
        <P
          use="dark"
          size="small"
        >
          Enter your username or email and we’ll send you a link to reset password.
        </P>
        <P use="dark">Email</P>
        <Input
          value={values.email}
          onChange={formik.handleChange}
          name="email"
          error={errors.email}
        />
        <div className={styles.buttonWrapper}>
          <Button
            type="submit"
            name="SEND LINK TO RESET"
            use="superBlue"
            fill
            loading={isLoading}
            disabled={isButtonDisabled}
          />
        </div>
      </Card>
    </form>
  );
};

export default ResetPassword;
